export const SET_TOAST = 'SET_TOAST';
export const setToast = (text, toastType = 'err') => ({
  type: SET_TOAST,
  text,
  toastType,
});

export const CLEAR_TOAST = 'CLEAR_TOAST';
export const clearToast = () => ({
  type: CLEAR_TOAST,
});
